import styled from 'styled-components';
import { colors, colorAliases } from '../../../../variables/colors.js';

var HotelHitBottomLink = styled.a.withConfig({
  displayName: "hotelHitBottomLink__HotelHitBottomLink",
  componentId: "sc-1vc63it-0"
})(["display:flex;justify-content:flex-end;align-items:center;background:", ";color:", ";font-size:14px;padding:8px 4px;box-shadow:0 0 1px ", ";.no-touch &:hover{background:#f2e8dd;}.sg-hotel-hit-bottom__link-icon{margin-left:5px;}"], colors.sand, colors.almostblack, colorAliases.shadow);

export { HotelHitBottomLink };
//# sourceMappingURL=hotelHitBottomLink.js.map
